import { useCallback, useState } from "react";
import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import Popup from "../../../components/Popup";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import InfoGenesis from "../../../assets/img/SolutionsIcons/AgilysysInfoGenesis.svg";
import { Header } from "../../../components/Header";

const InfoGenesisFPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const [showVideo, setShowVideo] = useState<boolean>(false);
    return(
        <div className="page splash infoGenesisFPage">
            <div className="page-title"><img src={InfoGenesis} alt="" /></div>
            <Header />
            <div className="text-blocks">
                <div className="std-text">
                An award-winning enterprise-class point-of-sale solution that
processes transactions in the highest volume, most demanding environments.{'\n\n'}
                </div>
                <div className="std-text">
                A comprehensive POS system, it combines highly interactive
terminal and tablet touchscreen applications supporting
Windows, Android and iOS devices. Its robust reporting and
analysis features, extensive enterprise-grade menu and item
configuration capabilities, and multi-language support, help
to drive service flexibility and increased operational
efficiency.{'\n\n'}
                </div>
                <div className="std-text">
                The result is improved F&B operations and increased
                revenue across venues.
                </div>
            </div>
            <div className="play-video" onClick={()=>{
                _logEvent('click', "Solutions - InfoGenesis", "Play Video");
                addFlow("Play Video");
                setShowVideo(true)}}>
                <PlayTriangle />
                Play Video
            </div>
            {/*<img className="img-1" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/InfoGenesis1.png"} alt="" />*/}
            <img className="img-2" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/Infogenesis2.png"} alt="" />
            <Popup showPopup={showVideo} setShowPopup={()=>setShowVideo(false)} disableOffClick={true}>
                <>{showVideo && <video 
                autoPlay
                controls
                src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/InteractiveInfoGenesis.mp4"} />}</>
            </Popup>
        </div>
    )
}

export default InfoGenesisFPage;